import React, { useState, useEffect } from "react";
import BackBtn from "../../common/backBTN";
import { Link } from "react-router-dom";

function EwalletList() {
  const [ewallets, setEwallets] = useState([]);

  // API call
  const fetchOther = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get/other/phone`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        console.error("Failed to fetch e-wallet list");
        return;
      }

      const data = await response.json();
      // ধরে নিচ্ছি backend থেকে আসছে data.data (array)
      setEwallets(data.data || []);
      console.log("Fetched ewallets:", data.data);
    } catch (error) {
      console.error("Error fetching ewallet list:", error);
    }
  };

  useEffect(() => {
    fetchOther();
  }, []);

  return (
    <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
      <div>
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-myEWallet mc-default-header am-navbar am-navbar-light"
          >
            <BackBtn />
            <div className="am-navbar-title">Bind E-wallet</div>
            <div className="am-navbar-right" />
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>

        <div>
          <div className="my-ew-banks-wrap">
            <div className="withdraw-bank-card-ew">
              <div className="cards-title">
                E-wallet added : {ewallets.length}
              </div>

              {/* যদি কোনো wallet না থাকে */}
              {ewallets.length === 0 ? (
                <div className="no-bank-card">
                  <span>Empty E-Wallet</span>
                </div>
              ) : (
                <div className="cards-list">
                  {ewallets.map((item, index) => (
                    <div className="EN card-item" key={index}>
                      <div className="card-content">
                        <div className="item-top">
                          <div className="item-icon">
                            <img
                              src="https://cdn-icons-png.flaticon.com/512/3757/3757881.png"
                              alt=""
                              style={{width: '50px'}}
                            />
                          </div>
                          <div className="item-info">
                           
                            <div className="bank-num">
                              *******{item.contract_value.slice(-4)}
                            </div>
                          </div>
                        </div>
                        <div className="item-bottom">
                          {new Date(item.created_at).toISOString().slice(0, 10)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              <div className="bottom-info">
                <div className="cards-tips">Maximum 2 allowed</div>

                
                {ewallets.length < 2 ? (
                  <Link to="/addEwallet" className="add-card-btn">
                    <svg className="am-icon am-icon-card-add_ac68ae20 am-icon-md">
                      <use xlinkHref="#card-add_ac68ae20" />
                    </svg>
                  </Link>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EwalletList;
